import React from 'react'
import 'firebase/firestore'
import 'firebase/auth'
import Signup from './SignUp'
import Carpool from './Carpool'
import { Container, Nav, Navbar } from 'react-bootstrap'
import {  Routes, Route, useNavigate } from 'react-router-dom'
import Login from './Login'
import ForgotPassword from './ForgotPassword'
import ProtectedRoute from './ProtectedRoute'
import RidePagePassenger from './RidePagePassenger'
import RidePageDriver from './RidePageDriver'
import UpdateProfile from './UpdateProfile'
import { useAuth } from "../contexts/AuthContext"
import NewRide from "./NewRide"
import logo from './logo.png'
import JoinRide from "./JoinRide";
import About from "./About";

function App() {
  const navigate = useNavigate();
  const { logout } = useAuth()

  async function handleLogout() {
    try {
      await logout()
      navigate("/login")
    } catch {
      console.log("Failed to logout")
    }
  }

  return (
      <>
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <>
        <Navbar className="navbar" bg="primary" variant="dark" fixed='top'>
          <Container style={{ height: 50, position:"sticky", top:0}}>
            <a href="/">
              <img
                src={logo}
                alt="Logo"
                style={{ width: 100, marginTop: 4, marginRight: 7 }}
              />
            </a>
            <Nav className="me-auto">
              <Nav.Link href="/new-ride">Create a Ride</Nav.Link>
              <Nav.Link href="/join-ride">Join a Ride</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <Nav.Link href="/update-profile">Update Profile</Nav.Link>
            </Nav>
          </Container>
        </Navbar>
      </>
      <Navbar bg="light" fixed='bottom' expand='md'>
        <Container>
          <Navbar.Brand href="#" onClick={handleLogout}>Logout</Navbar.Brand>
        </Container>
      </Navbar>
      <div className="w-100" style={{ maxWidth: "650px", position:"relative", top:70 }}>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <ProtectedRoute>
                <Carpool />
              </ProtectedRoute>
            }
          />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/ride-page-driver/:id"
            element=
            {
              <ProtectedRoute>
                <RidePageDriver />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ride-page-passenger/:id"
            element=
            {
              <ProtectedRoute>
                <RidePagePassenger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new-ride"
            element=
            {
              <ProtectedRoute>
                <NewRide />
              </ProtectedRoute>
            }
          />
          <Route
            path="/join-ride"
            element={
            <ProtectedRoute>
              <JoinRide />
            </ProtectedRoute>
            }
          />
          <Route
            path="/about"
            element={
              <About />
            }
          />
          <Route
            path="/update-profile"
            element=
            {
              <ProtectedRoute>
                <UpdateProfile />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
      <div className="h-100" style={{ top:70}}></div>
    </Container>
</>
  )
}

export default App;
